/* IMPORT REACT */
import { useContext, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useModal } from '../../context/ModalContext';
import styles from "./Footer.module.css";
import theme from '../../themes/ThemeLoader';

/* IMPORT CONTEXTS */
import { StoresContext } from '../../context/StoresContext';
import { ProductContext } from '../../context/ProductContext';
import { ExpiredProductContext } from '../../context/ExpiredProductContext';
import { AuthContext } from '../../context/AuthContext';
import { UserContext } from '../../context/UserContext';
import { ClientContext } from '../../context/ClientContext';

/* IMPORT TOASTIFY */
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  ADMIN_STORES_ROUTE,
  ADMIN_USERS_ROUTE,
  ADMIN_IMPORT_ROUTE,
  ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
  SUPER_ADMIN_CLIENTS_ROUTE,
  SUPER_ADMIN_USERS_ROUTE
} from '../../utils/Constants';

const Footer = () => {
  const { pathname } = useLocation();
  const { selectedStore } = useContext( StoresContext );
  const { selectedProduct, productIds } = useContext( ProductContext );
  const { selectedExpiredProduct, expiredproductIds, setIsMoreInformation } = useContext( ExpiredProductContext );
  const { selectedUser } = useContext( UserContext );
  const { selectedClient } = useContext( ClientContext );
  const { user } = useContext( AuthContext );
  const { 
    openCreateStoreModal, 
    openDeleteStoreModal,
    openEditStoreModal,

    openCreateUserModal,
    openDeleteUserModal,
    openEditUserModal,

    openCreateProductModal, 
    openDeleteProductModal,
    openEditProductModal,

    openEditExpiredProductModal,
    openDeleteExpiredProductModal,

    openCreateClientModal, 
    openDeleteClientModal,
    openEditClientModal,

    openCreateAdminUserModal,
    openDeleteAdminUserModal,
    openEditAdminUserModal,

  } = useModal();

  const [error, setError] = useState(false);
  const handleEditProduct = () => {
    if (selectedProduct?.length > 1) {
      toast.error("Você só pode editar um produto por vez.")
      setError(true);
    } else {
      if(selectedProduct !== null && selectedProduct !== undefined) {
        openEditProductModal();
      }
      setError(false);
     
    }
  };

  const handleDeleteProduct = () => {
    if (productIds?.length >= 1 || selectedStore != null) {
      openDeleteProductModal()
    } else {
      return null;
    }
  };

  const handleEditExpiredProduct = () => {
    if (selectedExpiredProduct?.length > 1) {
      toast.error("Você só pode editar um produto por vez.")
      setError(true);
    } else {
      if(selectedExpiredProduct !== null && selectedExpiredProduct !== undefined) {
        openEditExpiredProductModal();
      }
      setError(false);
    }
  };

  const handleDeleteExpiredProduct = () => {
    if (expiredproductIds?.length >= 1 || selectedStore != null) {
      openDeleteExpiredProductModal()
    } else {
      return null;
    }
  };


  const renderButtons = () => {
    switch (pathname) {
      
      case ADMIN_STORES_ROUTE:
        return user?.role === 'MASTER' ? (
          <>
            <button className={styles.buttonStyle} onClick={openCreateStoreModal}>Adicionar Loja</button>
            <button className={styles.buttonStyle} onClick={selectedStore ? openEditStoreModal : null}>Editar Loja</button>
            <button className={styles.buttonStyle} onClick={selectedStore ? openDeleteStoreModal : null}>Deletar Loja</button>
          </>
        ) : null;
      case ADMIN_USERS_ROUTE:
        return (
          <>
            <button className={styles.buttonStyle} onClick={ openCreateUserModal }>Adicionar Usuário</button>
            <button className={styles.buttonStyle} onClick={ selectedUser ? openEditUserModal : null }>Editar Usuário</button>
            <button className={styles.buttonStyle} onClick={ selectedUser ? openDeleteUserModal : null }>Deletar Usuário</button>
          </>
        );
      case ADMIN_EXPIRY_DATE_CONTROL_ROUTE:
        return (
          <>
            <button className={styles.buttonStyle} onClick={() => setIsMoreInformation((prev) => !prev)}>Ver Mais</button>
            <button className={styles.buttonStyle} onClick={ handleEditExpiredProduct }>Editar Produto</button>
            <button className={styles.buttonStyle} onClick={ handleDeleteExpiredProduct }>Deletar Produto</button>
          </>
        );
        case ADMIN_IMPORT_ROUTE:
          return (
            <>
              <button className={styles.buttonStyle} onClick={ openCreateProductModal }>Cadastrar Produto</button>
              <button className={styles.buttonStyle} onClick={ handleEditProduct }>Editar Produto</button>
              <button className={styles.buttonStyle} onClick={ handleDeleteProduct }>Deletar Produto</button>
            </>
          );
          
        case SUPER_ADMIN_CLIENTS_ROUTE:
          return (
            <>
              <button className={styles.buttonStyle} onClick={ openCreateClientModal }>Cadastrar Cliente</button>
              <button className={styles.buttonStyle} onClick={ selectedClient ? openEditClientModal : null }>Editar Cliente</button>
              <button className={styles.buttonStyle} onClick={ selectedClient ? openDeleteClientModal : null }>Deletar Cliente</button>
            </>
          );

        case SUPER_ADMIN_USERS_ROUTE:
          return (
            <>
              <button className={styles.buttonStyle} onClick={ openCreateAdminUserModal }>Cadastrar Usuário</button>
              <button className={styles.buttonStyle} onClick={ selectedUser ? openEditAdminUserModal : null }>Editar Usuário</button>
              <button className={styles.buttonStyle} onClick={ selectedUser ? openDeleteAdminUserModal : null }>Deletar Usuário</button>
            </>
          );

      default:
        return null;
    }
  };

  return (
    <footer className={styles.footerContainer} style={{ backgroundColor: theme.footerBackgroundColor }}>
      { error && <ToastContainer/>}
      <div className={styles.footerContent}>
        { renderButtons() }
        
      </div>
    </footer>
  );
};

export default Footer;
